export const environment = {
   production: true,
   domain: 'auth-fund.vistra.com',
   clientId: 'JxEKLjcg44bK9gUXc4sB7QMfspzpme57',
   audience: 'https://api.star.com',
   scope: 'openid profile email',
   baseUrl: 'https://starportal2.star.vistra.com/prodb-webportal-app-aia/',
   logout: 'https://starportal2.star.vistra.com/aia/',
   star_clientid: 'aia'
};
